import { Row, Col, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import { message } from 'antd';
import AddSensorModal from './AddSensorModal';
import { sensorService } from '@iso/services';
import SensorList from './SensorList';
import SensorDetail from '../../../Sensors/SensorDetail'; // Import SensorDetail

const SensorTab = (props) => {
    const [visibleSensorModal, setVisibleSensorModal] = useState(false);
    const [sensors, setSensors] = useState([]);
    
    // Navigation state - similar to your main Sensors component
    const [currentView, setCurrentView] = useState('list'); // 'list' or 'detail'
    const [selectedSensor, setSelectedSensor] = useState(null);

    useEffect(() => {
        getSensors();
    }, [props.assetId]);

    const handleOpenSensorModal = () => {
        setVisibleSensorModal(true);
    }

    const handleCloseSensorModal = () => {
        setVisibleSensorModal(false);
    }

    const handleAddSensor = () => {
        message.success(<IntlMessages id="propertyPage.mobModal.sensorTab.addSensorModal.success" />);
        setVisibleSensorModal(false);
        getSensors();
    }

    // Updated sensor click handler to match your main component pattern
    const handleSensorClick = (sensor) => {
        // Handle scroll issues like in your main component
        window.scrollTo({ top: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        
        // Try common container selectors
        const scrollableElement = document.querySelector('.ant-layout-content') || 
                                document.querySelector('.layout-wrapper') ||
                                document.querySelector('[data-scrollable="true"]');
        if (scrollableElement) {
            scrollableElement.scrollTop = 0;
        }
        
        setSelectedSensor(sensor);
        setCurrentView('detail');
    };

    // Back to list handler
    const handleBackToList = () => {
        setCurrentView('list');
        setSelectedSensor(null);
    };

    const getSensors = () => {
        sensorService.getAssetSensors(props.assetId).then(res => {
            if (res.code === '0000') {
                setSensors(res.sensors);
            } else {
                setSensors([]);
            }
        })
    }
    // Render based on current view - similar to your main component
    if (currentView === 'detail' && selectedSensor) {
        return (
            <SensorDetail 
                sensor={selectedSensor}
                onBack={handleBackToList}
                timezone={props.timezone || 'Australia/Melbourne'} // Use prop or default
                isModal={true} // Add this prop to enable modal-specific styling
            />
        );
    }

    // Default list view
    return (
        <>
            { sensors.length === 0 && <Row>
                <Col xs={{ span: 7 }} md={{ span: 7 }}>
                    <Button
                        key="submit"
                        className="btn-create-breed"
                        type="primary"
                        onClick={handleOpenSensorModal}
                    >
                        <IntlMessages id="propertyPage.mobModal.sensorTab.addButton" />
                    </Button>
                </Col>
            </Row> }

            <br />

            <SensorList 
                data={sensors} 
                onSensorClick={handleSensorClick} // Pass the updated handler
                getSensors={getSensors}
            />

            <AddSensorModal
                visible={visibleSensorModal}
                onCancel={handleCloseSensorModal}
                onSaved={handleAddSensor}
                assetId={props.assetId}
                propertyId={props.propertyId}
            />
        </>
    )
}

export default SensorTab;